"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketLifecycleOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=DeleteBucketLifecycleOutput.js.map